import { render, staticRenderFns } from "./FolderDisplay.vue?vue&type=template&id=05d10674&scoped=true&"
import script from "./FolderDisplay.vue?vue&type=script&lang=js&"
export * from "./FolderDisplay.vue?vue&type=script&lang=js&"
import style0 from "./FolderDisplay.vue?vue&type=style&index=0&id=05d10674&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05d10674",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/__w/ddv-home/ddv-home/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('05d10674')) {
      api.createRecord('05d10674', component.options)
    } else {
      api.reload('05d10674', component.options)
    }
    module.hot.accept("./FolderDisplay.vue?vue&type=template&id=05d10674&scoped=true&", function () {
      api.rerender('05d10674', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FolderDisplay.vue"
export default component.exports